var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.classes,attrs:{"role":"img","title":"Loading...","viewBox":_vm.viewBox,"width":_vm.width + 'px',"height":_vm.width + 'px'}},[_c('circle',{staticClass:"c-spinner-circle",attrs:{"cx":_vm.circlePosition,"cy":_vm.circlePosition,"r":_vm.radius,"stroke-width":_vm.strokeWidthValue}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a93e2e80","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/Spinner.vue
// module id = null
// module chunks = 